import api from 'config/Api/Api';

const baseEndpoint = 'v1/crm-integration';
const baseEndpointNew = "v1"

export default {

  getIntegrations( params ) {
    return api.get( `${baseEndpoint}`, params );
  },

  getAuthorizationUrl( id ) {
    return api.get( `${baseEndpoint}/${id}/authorization` );
  },

  authenticateCrm( id, data ) {
    return api.post( `${baseEndpoint}/${id}/authentication`, data );
  },

  checkIntegrationStatus(params){
    return api.get( `${baseEndpointNew}/check-crm`, params );
  },

  deleteData(id){
    return api.delete(`${baseEndpointNew}/remove-crm/${id}`);
  }

};

  